import * as React from 'react';
import { observer } from 'mobx-react';
import { ISkidAndRollControlParams } from './ISkidAndRollControlParams';
import { SkidAndRollGraph } from './SkidAndRollGraph/SkidAndRollGraph';
import { ISkidAndRollGraphParams } from './SkidAndRollGraph/ISkidAndRollGraphParams';
import { ReportKind } from 'Data';

export interface ISkidAndRollControlState {
  enoughDataToShowSkidAndRoll: boolean;
}

@observer
export class SkidAndRollControl extends React.Component<
  ISkidAndRollControlParams,
  ISkidAndRollControlState
> {
  constructor(props: ISkidAndRollControlParams) {
    super(props, undefined);
    this.state = {
      ...this.state,
      ...{ enoughDataToShowSkidAndRoll: this.hasEnoughDataToShowSkidAndRoll(props) },
    };
  }

  updateStateFromProps(nextProps: any) {
    //if (nextProps.selectedStroke == null && nextProps.selectedAverage == null) {
    //    this.setState({ measurementsData: null });
    //}

    this.setState({ enoughDataToShowSkidAndRoll: this.hasEnoughDataToShowSkidAndRoll(nextProps) });
  }

  hasEnoughDataToShowSkidAndRoll(nextProps: any) {
    if (nextProps.measurementsData?.skidDistance && nextProps.measurementsData.total != null) {
      return true;
    } else {
      return false;
    }
  }

  componentWillReceiveProps(nextProps: any) {
    this.updateStateFromProps(nextProps);
  }

  renderInfoBoxes() {
    if (
      this.props.reportKind === ReportKind.puttingMultiGroupReport ||
      this.props.reportKind === ReportKind.puttingSingleGroupReport
    ) {
      if (this.props.selectedStrokesGroups.length === 0) {
        return this.renderInfoBox(
          'You have no groups selected',
          'Select a group and a shot to see the results.'
        );
      }
      if (
        !this.props.selectedStroke &&
        !this.props.selectedAverage &&
        this.props.selectedStrokesGroups?.length &&
        this.props.selectedStrokesGroups.length !== 0
      ) {
        return this.renderInfoBox('Choose a stroke or average to see the Skid and Roll view.', '');
      }
      if (
        this.state.enoughDataToShowSkidAndRoll === false &&
        this.props.selectedStrokesGroups?.length &&
        this.props.selectedStrokesGroups.length !== 0 &&
        ((!this.props.selectedStroke && this.props.selectedAverage) ||
          (this.props.selectedStroke && !this.props.selectedAverage))
      ) {
        return this.renderInfoBox(
          'There is not enough data to display the Skid and Roll view.',
          'Select another shot or average to see the results.'
        );
      }
    }
    if (
      this.props.reportKind === ReportKind.puttingSingleShotReport &&
      this.state.enoughDataToShowSkidAndRoll === false
    ) {
      return this.renderInfoBox('There is not enough data to display the Skid and Roll view.', '');
    }
    if (
      this.props.reportKind === ReportKind.puttingCompareReport &&
      this.state.enoughDataToShowSkidAndRoll === false
    ) {
      return this.renderInfoBox('There is not enough data to display the Skid and Roll view.', '');
    }
    return null;
  }

  renderInfoBox(line1: string, line2: string) {
    return (
      <div className={`info-container ${this.props.reportKind}`}>
        <p>{line1}</p>
        <p>{line2}</p>
      </div>
    );
  }

  render() {
    let infoBoxes = this.renderInfoBoxes();

    return (
      <div
        className="SkidAndRollControl"
        style={{ width: this.props.widthOfContainer, height: this.props.heightOfContainer }}
      >
        {infoBoxes}
        <SkidAndRollGraph {...this.getSkidAndRollGraphParameters()} />
      </div>
    );
  }

  private getSkidAndRollGraphParameters() {
    const result: ISkidAndRollGraphParams = {
      measurementsData: this.props.measurementsData,
      unitPresentation: this.props.unitPresentation,
      clubType: this.props.clubType,
      selectedGroupOfStrokes: this.props.selectedGroupOfStrokes,
      selectedStroke: this.props.selectedStroke,
      selectedAverage: this.props.selectedAverage,
      //onDataTypeChanged: this.props.onDataTypeChanged,
      selectedView: this.props.selectedView,
      selectedStrokesGroups: this.props.selectedStrokesGroups,
      isTps: this.props.isTps,
      isWeb: this.props.isWeb,
      reportKind: this.props.reportKind,
      widthOfContainer: this.props.widthOfContainer,
      heightOfContainer: this.props.heightOfContainer,
      containerMarginTop: this.props.containerMarginTop,
      containerMarginBottom: this.props.containerMarginBottom,
      containerMarginLeft: this.props.containerMarginLeft,
      containerMarginRight: this.props.containerMarginRight,
    };
    return result;
  }
}
